<template>
  <div>
    <v-card
      class="template-gallery__item new"
      @click="onTemplateGalleryItemClick"
      :color="$store.getters.userCanAddNewTemplates ? 'orange darken-3' : 'grey lighten-1'"
      :elevation="$store.getters.userCanAddNewTemplates ? '1' : '0'"
      :disabled="!$store.getters.userCanAddNewTemplates"
    >
      <div style="display: flex; flex-direction: column; text-align: center; align-items: center; padding: 20px 15px;">
        <v-avatar size="65" tile>
          <v-icon large >mdi-table-large</v-icon>
        </v-avatar>
        <v-card-title style="justify-content: center; padding: 0; margin-top: 5px; font-size: 20px; width: calc(100% - 10px);">
          <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
            {{addNewTemplate }}
          </div>
        </v-card-title>
      </div>
    </v-card>

  </div>
</template>
<script>
import Mixin from '@/mixins/mixin';

export default {
  name: 'TemplateGalleryNewItem',
  props: {
    onTemplateGalleryItemClick: Function,
  },
  mixins: [Mixin],
  computed: {
    addNewTemplate() {
      const { language } = this.$store.state.user.settings;
      let result = '';
      if (this.$store.state.languages) {
        result = this.translate('ui_add_new_template_btn', language);
      }
      return result;
    },
  },
};
</script>
